import React, { useCallback, useContext, useEffect, useMemo, useState } from "react";
import { Spin, message, Input } from "antd";
import { LoadingOutlined } from "@/utils/antdIcon";
import { LoginFormContext, LoginFormContextType } from "../../utils";
import IconFont, { IconArrowRight, IconGroup, IconJoyMeetingGroup } from "@/components/icon";
import JoinOtherTeam from "./JoinOtherTeam";
import CreateTeam from "./CreateTeam";
import { BackNav } from "../../comps";
import GlobalContext, { GlobalContextConfig } from "@/context/GlobalContext";
import { ApprovaTeamUserInfoList, InviteUserInfo, TeamUserInfo } from "@/types/LoginPage";
import { useTranslation } from "react-i18next";
import { getWebEnvObj } from "@/utils";
import JoinPersonalTeam from "./JoinPersonalTeam";
import ApplyingTeams from "./ApplyingTeams";
import stylesLess from "../../index.module.less";
import toLogin from "@/assets/img/login/toLogin.png"
const {
  REACT_APP_OSS_BASE_URL = "https://focus-desktop.s3.cn-north-1.jdcloud-oss.com"
} = getWebEnvObj();
const teamBgImg = `${REACT_APP_OSS_BASE_URL}/statics/images/team_bg.png`;
enum JoinPath {
  Init,
  JoinOtherTeam,
  CreateTeam,
  JoinPersonalTeam
}

function EntryItem({
  title,
  desc,
  styles,
  icon,
  clickHandle
}: {
  styles: any;
  title: string;
  desc?: string;
  icon: any;
  clickHandle: () => void;
}) {
  return (
    <div
      style={{
        backgroundPosition: "top right",
        // backgroundSize: "99px 47px",
        // backgroundImage: `url(${teamBgImg})`,
        backgroundRepeat: "no-repeat",
        borderRadius: 8,
        border: "0.8px solid #E6E6E6",
        background: "#FFF",
        padding: "12px 16px",
        marginBottom: "12px"
      }}
      className={`${desc} ? ${stylesLess["entry-hover"]} : (${stylesLess["entry-hover"]} ${stylesLess.noDesc})`}
      onClick={clickHandle}
      key={title}
    >
      <div style={{ marginRight: "32px" }}>
        <p
          style={{
            textAlign: "left"
          }}
        >
          {/* {icon} */}
          <span className={stylesLess.title} style={{ ...styles }}>
            {title}
          </span>
        </p>
        {desc && <div className={stylesLess.desc} style={{fontSize: 12, color: "#818793", marginTop: 8}}>{desc}</div>}
      </div>
      {IconArrowRight}
    </div>
  );
}

export default function JoinTeam(props: { isLogin?: boolean; onCloseModal?: Function }) {
  const { isLogin = true, onCloseModal } = props;
  const { service, appRuntimeEnv, authInfo: authData } = useContext<GlobalContextConfig>(
    GlobalContext
  );
  const {
    navigate,
    onMobileChange,
    setResendLastTs,
    authInfo,
    enterApplication
  } = React.useContext<LoginFormContextType>(LoginFormContext);
  const { t } = useTranslation("common");
  const [joinPath, setJoinPath] = useState(JoinPath.Init);
  const canCreateTeamConfig = appRuntimeEnv.getUIConfig("canCreateTeam");
  const canJoinTeamConfig = appRuntimeEnv.getUIConfig("canJoinTeam");
  const canJoinPersionalConfig = appRuntimeEnv.getUIConfig("canJoinTeam");
  //   const canCreateTeam = typeof canCreateTeamConfig === "undefined" || canCreateTeamConfig === true;
  //   const canJoinTeam = typeof canJoinTeamConfig === "undefined" || canCreateTeamConfig === true;
  //   const canPersonal =
  //     typeof canJoinPersionalConfig === "undefined" || canJoinPersionalConfig === true;
  const canCreateTeam = true;
  const canJoinTeam = true;
  const [canPersonal, setCanPersonal] = useState(false);

  const checkPersonalTeam = useCallback(async () => {
    try {
      const content = await service.focusService.checkPersonalTeam();
      // console.log(content, "checkPersonalTeamcontent");
      if (content?.hasPersonalTeam === false) {
        setCanPersonal(true);
      }
    } catch (e) {
      // console.log(e, "e>ls");
      // onGlobalError(e);
      //  message.warning(e?.errorMsg || e?.msg || t("request-error"));
    }
  }, []);
  useEffect(() => {
    checkPersonalTeam();
  }, [checkPersonalTeam]);
  const checkCreateTeam = useCallback(async () => {
    try {
      const content = await service.focusService.validateTeamCount({
        // @ts-ignore

        ownerId: authData?.userId || authInfo?.userId
      });

      if (content) {
        setJoinPath(JoinPath.CreateTeam);
      }
    } catch (e) {
      // console.log(e, "e>ls");
      // onGlobalError(e);
      message.warning(e?.errorMsg || e?.msg || t("request-error"));
    }
  }, []);
  const initEle = useMemo(() => {
    return (
      <div>
        {isLogin ? (
          <>
            <BackNav
              clickHandle={() => {
                onMobileChange("");
                setResendLastTs(-1);
                setTimeout(() => {
                  navigate("step1");
                }, 0);
              }}
              title={t("login.changeLogin")}
              subtitle={t("login.selectMode")}
              // desc={t("login.teamDesc")}
            />
            <div
              className={stylesLess["back-to-login"]}
              onClick={() => {
                onMobileChange("");
                setResendLastTs(-1);
                setTimeout(() => {
                  navigate("step1");
                }, 0);
              }}
            >
              <img src={toLogin} width="18px" style={{marginRight: 2}}/>
              切换登录
            </div>
          </>
        ) : //
        onCloseModal ? (
          <BackNav
            clickHandle={() => {
              // onMobileChange("");
              // setResendLastTs(-1);
              onCloseModal();
            }}
            title={t("login.changeLogin")}
            subtitle={t("login.selectMode")}
            // desc={t("login.teamDesc")}
          />
        ) : (
          // <h4 style={{ margin: "20px 0px", fontSize: "20px" }}>{t("login.selectMode")}</h4>
          <div className={stylesLess.inputCodeTitle}>{t("login.selectMode")}</div>
        )}
        <div className={stylesLess.teamScroller} style={{ height: "365px", overflowY: "auto" }}>
          <div>
            {canJoinTeam && (
              <EntryItem
                styles={
                  {
                    //   color: "#F7B500"
                  }
                }
                title={t("login.joinTeam", {
                  appName: appRuntimeEnv.productName
                })}
                desc={t("login.joinDesc")}
                icon={IconGroup}
                clickHandle={() => setJoinPath(JoinPath.JoinOtherTeam)}
              />
            )}
            {canCreateTeam && (
              <EntryItem
                styles={
                  {
                    // color: color.primary,
                  }
                }
                title={t("login.createTeam", {
                  appName: appRuntimeEnv.productName
                })}
                desc={t("login.createDesc")}
                icon={IconJoyMeetingGroup}
                clickHandle={checkCreateTeam}
              />
            )}
            {canPersonal && (
              <EntryItem
                styles={
                  {
                    // color: color.primary,
                  }
                }
                title={t("login.usePersonal", {
                  appName: appRuntimeEnv.productName
                })}
                // desc={t("login.createDesc")}
                icon={IconJoyMeetingGroup}
                clickHandle={() => setJoinPath(JoinPath.JoinPersonalTeam)}
              />
            )}
          </div>
          <ApplyingTeams />
        </div>
      </div>
    );
  }, [canPersonal]);

  return (
    <>
      {joinPath === JoinPath.Init ? initEle : null}
      {joinPath === JoinPath.JoinOtherTeam ? (
        <JoinOtherTeam goBack={() => setJoinPath(JoinPath.Init)} />
      ) : null}
      {joinPath === JoinPath.CreateTeam ? (
        <CreateTeam goBack={() => setJoinPath(JoinPath.Init)} isLogin={isLogin} />
      ) : null}
      {joinPath === JoinPath.JoinPersonalTeam ? (
        <JoinPersonalTeam goBack={() => setJoinPath(JoinPath.Init)} isLogin={isLogin} />
      ) : null}
    </>
  );
}
